export default __webpack_public_path__ + "static/media/slot14.8b076869.png";